import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const lang = JSON.parse(localStorage.getItem('lang'));
i18n
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: lang?.lang ?? 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        // language resources
        resources: {
            en: {
                translation: {
                    expandTutorCamera: 'Expand teacher camera',
                    lessonPacing: 'Lesson pacing',
                    onLessonBreak: 'Lesson break',
                    lessonAgenda: 'Lesson agenda',
                    completeAgendaItem: 'Complete agenda item',
                    pacingUpdateError: 'Lesson pacing could not be updated.',
                    exitTutorCamera: 'Exit expanded camera',
                    teacherCamera: 'Teacher camera',
                    cameraUnavailable: 'Teacher camera is unavailable',
                    cameraConnecting: 'Waiting for teacher video',
                    privatMessage: "Private Message",
                    fiveMinLeft: "Warning! 5 Minutes left of the session duration ",
                    preparingEndSession: "Preparing to end session in: ",
                    extend10: "Extend for 10 minutes?",
                    extend5: "Extend for 5 minutes?",
                    ended: "Ended",
                    started: "Started",
                    notStarted: "Not Started",
                    asteacher: 'As Instructor',
                    asstudent: 'As Attendee',
                    startSession: 'Start Session',
                    socketErrored: 'Failed to connect to our servers, please check your internet connection. Trying to reconnet...',
                    not_authorized: "Someone logged in with your account, please log in again.",
                    noCoursFound: "No Courses Found",
                    createCourse: "Create New Course",
                    exploreCourses: "Explore Our Courses",
                    startMeeting: "Start Meeting",
                    endMeeting: "End Meeting",
                    resume: "Resume",
                    stopSession: "End Session",
                    undo: "Undo",
                    redo: "Redo",
                    chooseAScreen: "Please choose screen to share:",
                    chooseMicVideoSettings: "Choose what do you want to stream:",
                    micOnly: "Audio only",
                    micAndVideo: "Video and audio",
                    dashboard: "Dashboard",
                    events: "Upcoming Events",
                    share_screen: "Share Screen",
                    board: "Board",
                    noMoreTabs: "You can't open more tabs",
                    ok: "OK",
                    close: "Cancel",
                    error500: "Somthing went wrong!!",
                    phonenumber: 'Phone Number',
                    password: "Password",
                    rememberme: "Remember me",
                    login: "Log In",
                    forgotpassword: "Forgot Password?",
                    profile: "Profile",
                    logout: "Log Out",
                    messages: "Messages",
                    notifications: "Notifications",
                    search: "Search ...",
                    mycourses: "My Courses",
                    more: "More",
                    poweredby: "Powered By",
                    sp: "SP",
                    buy: "BUY",
                    attachments: "Attachments",
                    links: "Links",
                    finaltest: "Final Test",
                    descussion: "Descussion",
                    quiz: "Quiz",
                    comments: "Comments",
                    reviews: "Reviews",
                    addreview: "Add Review",
                    yourreview: "Your Review ...",
                    sendmessage: "Send Message",
                    poll: "POLL",
                    attendeelist: "Attendee List",
                    pause: "Pause Recording",
                    elapsed: "Elapsed Time",
                    remaining: "Remaining Time",
                    uploaderheadertext: "Upload Board Content",
                    or: "or",
                    selectfiles: "to select file",
                    clickhere: "Click here",
                    draganddrop: "Drag and drop",
                    privacypolicy: "Privacy Policy",
                    support: "Support",
                    contactus: "Contact us",
                    chatbox: 'Comments',
                    private_message_to: 'Send private message to ',
                    mic_devices: "Please Select Mic Device",
                    cam_devices: "Please Select Camera Device",
                    test_audio: 'Test microphone device',
                    test_video: "Test camera",
                    cam_mic_settings: "Camera and Microphone Settings",
                    ask_for_mic: "The teacher wants to give you the ability to talk using the mic",
                    apologize: "I apologize",
                    accept: "Accept",
                    
                    // Guest Join
                    joinMeeting: "Join Meeting",
                    enterNameToJoin: "Enter your name to join the session",
                    yourName: "Your Name",
                    enterYourName: "Enter your name",
                    joinNow: "Join Now",
                    joiningMeeting: "Joining meeting",
                    haveAccount: "Already have an account?",
                    welcome: "Welcome back! Please login to continue.",
                    invalidPhone: "Please enter a valid phone number",
                    passwordRequired: "Password is required",
                    downloadApp: "Download App",
                    downloadAppMessage: "Download the Ropera app for a better experience",
                    
                    // Mobile Rotate
                    rotatePhone: "Please Rotate Your Phone",
                    rotatePhoneMessage: "For the best classroom experience, please rotate your device to landscape mode.",
                    landscape: "Landscape Mode",
                    
                    // Waiting states
                    waitingForTeacher: "Waiting for teacher...",
                    quizComingSoon: "Quiz Coming Soon!",
                    teacherPreparingQuiz: "The teacher is preparing a quiz for you..."
                }
            },
            ar: {

                translation: {
                    expandTutorCamera: 'تكبير كاميرا المدرس',
                    lessonPacing: 'إيقاع الدرس',
                    onLessonBreak: 'استراحة الدرس',
                    lessonAgenda: 'جدول الدرس',
                    completeAgendaItem: 'إكمال بند الجدول',
                    pacingUpdateError: 'تعذر تحديث إيقاع الدرس.',
                    exitTutorCamera: 'الخروج من عرض الكاميرا المكبر',
                    teacherCamera: 'كاميرا المدرس',
                    cameraUnavailable: 'كاميرا المدرس غير متاحة',
                    cameraConnecting: 'بانتظار بث فيديو المدرس',
                    privatMessage: "رسالة خاصة",
                    fiveMinLeft: "تحذير! تبقى خمسة دقائق من وقت الجلسة ",
                    preparingEndSession: "تحضير انهاء الجلسة خلال: ",
                    extend10: "تمديد 10 دقائق؟",
                    extend5: "تمديد 5 دقائق؟",
                    ended: "انتهت",
                    started: "بدأت",
                    notStarted: "لم تبدأ",
                    asteacher: 'كمُحاضر',
                    asstudent: 'كطالب / مدعوّ',
                    startSession: 'ابدأ الجلسة',
                    socketErrored: 'فشل الاتصال بالخادم، الرجاء التأكد من اتصالك بالانترنت. يجري اعادة محاولة الاتصال...',
                    not_authorized: "تم تسجيل الدخول من حسابك من جهاز آخر يرجى إعادة تسجيل الدخول.",
                    noCoursFound: "لا يوجد أية كورسات",
                    exploreCourses: "ألقِ نظرة على دوراتنا",
                    createCourse: "أنشئ دورة جديدة",
                    startMeeting: "بدء الاجتماع",
                    endMeeting: "إنهاء الاجتماع",
                    resume: "متابعة",
                    stopSession: "إنهاء الجلسة",
                    undo: "تراجع",
                    redo: "عودة عن التراجع",
                    chooseAScreen: "الرجاء اختيار شاشة للمشاركة:",
                    chooseMicVideoSettings: "اختر ماذا تريد ان تشارك",
                    micOnly: "الصوت فقط",
                    close: "إلغاء",
                    micAndVideo: "الصوت والصورة",
                    dashboard: "لوحة التحكم",
                    events: "الاحداث القادمة",
                    share_screen: "مشاركة الشاشة",
                    board: "نافذة",
                    noMoreTabs: "لا يمكنك فتح نوافذ جديدة",
                    ok: "حسناً",
                    error500: "حدث خطأ ما",
                    phonenumber: 'رقم الجوال',
                    password: "كلمة السر",
                    rememberme: "تذكرني",
                    login: "تسجيل الدخول",
                    forgotpassword: "نسيت كلمة المرور؟",
                    logout: "تسجيل الخروج",
                    messages: "الرسائل",
                    notifications: "الاشعارات",
                    profile: "الصفحة الشخصية",
                    search: "ابحث ...",
                    mycourses: "دوراتي",
                    more: "المزيد",
                    poweredby: "طور من قبل",
                    sp: "ل.س",
                    buy: "شراء",
                    attachments: "المرفقات",
                    links: "المراجع",
                    finaltest: "الاختبار النهائي",
                    descussion: "النقاش",
                    quiz: "الاختبار",
                    comments: "التعليقات",
                    reviews: "التقييمات",
                    addreview: "اضافة تقييم",
                    yourreview: "ضع تقييمك هنا ...",
                    sendmessage: "ارسل رسالة",
                    poll: "سؤال",
                    attendeelist: "قائمة الحاضرين",
                    pause: "أيقاف التسجيل مؤقتاً",
                    elapsed: "الوقت المنقضي",
                    remaining: "الوقت المتبقي",
                    uploaderheadertext: "حمل محتوى اللوح",
                    or: "أو",
                    selectfiles: "لاختيار الملف",
                    clickhere: "إنقر هنا",
                    draganddrop: "اسحب وافلت",
                    privacypolicy: "سياسة الخصوصية",
                    support: "الدعم الفني",
                    contactus: "اتصل بنا",
                    chatbox: 'التعليقات',
                    private_message_to: 'ارسال رسالة خاصة لـ',
                    mic_devices: "الرجاء اختيار الميكروفون",
                    cam_devices: "الرجاء اختيار الكاميرا",
                    test_audio: 'تجريب الميكروفون',
                    test_video: "تجريب الكاميرا",
                    cam_mic_settings: "اعدادات الكاميرا والميكروفون",
                    ask_for_mic: "يرغب المحاضر باعطائك أحقية الكلام باستخدام الميكروفون",
                    apologize: "أعتذر",
                    accept: "موافق",
                    
                    // Guest Join
                    joinMeeting: "انضم للاجتماع",
                    enterNameToJoin: "أدخل اسمك للانضمام للجلسة",
                    yourName: "اسمك",
                    enterYourName: "أدخل اسمك",
                    joinNow: "انضم الآن",
                    joiningMeeting: "جاري الانضمام",
                    haveAccount: "لديك حساب؟",
                    welcome: "مرحباً بعودتك! الرجاء تسجيل الدخول للمتابعة.",
                    invalidPhone: "الرجاء إدخال رقم هاتف صحيح",
                    passwordRequired: "كلمة المرور مطلوبة",
                    downloadApp: "تحميل التطبيق",
                    downloadAppMessage: "حمل تطبيق روبيرا للحصول على تجربة أفضل",
                    
                    // Mobile Rotate
                    rotatePhone: "يرجى تدوير هاتفك",
                    rotatePhoneMessage: "للحصول على أفضل تجربة في الفصل الدراسي، يرجى تدوير جهازك إلى الوضع الأفقي.",
                    landscape: "الوضع الأفقي",
                    
                    // Waiting states
                    waitingForTeacher: "في انتظار المعلم...",
                    quizComingSoon: "اختبار قادم!",
                    teacherPreparingQuiz: "المعلم يحضر اختبارًا لك..."
                }
            },
        }
    });

export default i18n;
